import { render } from "./task-board-model.vue?vue&type=template&id=95f839a8"
import script from "./task-board-model.vue?vue&type=script&lang=js"
export * from "./task-board-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__